<div class="inline-message {{ type }}">
	<i class="fa fa-{{icon[type]}}"
	></i>
	<ng-content></ng-content>
</div>
